import type { StudioOption } from 'src/components/star-grid/reportStudio.types';
import type { PnlHierarchyMember, PnlHierarchyTree } from 'src/components/star-grid/starGridTypes';
const SHORT_YEAR_BASE = 2000;
export const studioScenarioYear = (label: string): number => {
  const full = label.match(/(?:^|\D)(20\d{2})(?=\D|$)/);
  if (full) return Number(full[1]);
  const short = label.match(/(?:^|FY|[- /])(\d{2})(?=\D|$)/i);
  return short ? SHORT_YEAR_BASE + Number(short[1]) : 0;
};
export const orderedStudioScenarios = <T extends Pick<StudioOption, 'label'>>(options: readonly T[]): T[] =>
  [...options].sort((a, b) => studioScenarioYear(b.label) - studioScenarioYear(a.label));
const orderedMembers = (members: readonly PnlHierarchyMember[]): PnlHierarchyMember[] =>
  orderedStudioScenarios(members).map((member) => ({ ...member, children: orderedMembers(member.children) }));
export const orderedStudioScenarioTree = (tree: PnlHierarchyTree | undefined, dimension: string): PnlHierarchyTree | undefined =>
  tree && /(?:^|[_\s])scenario$/i.test(dimension) ? { ...tree, members: orderedMembers(tree.members) } : tree;
